import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import {
  PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE,
  PLANNER_CLOSE_DIALOG_SAVE_TASKS_MEMO,
  PLANNER_SUBMIT_UNDER,
  PLANNER_SUBMIT_STATUS
} from 'apps/events';
import PlannerControllerBase from './base';
export default class DialogsController extends PlannerControllerBase {
  constructor(tag){
    super(tag);
    this.customEvent(PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE, (e) => {this.onCloseDialogCreateSchedule(e) });
    this.customEvent(PLANNER_CLOSE_DIALOG_SAVE_TASKS_MEMO, (e) => {this.onCloseDialogSaveTasksMemo(e) });
    this.customEvent(PLANNER_SUBMIT_UNDER,                 (e) => {this.onSubmitUnder(e) });
    this.customEvent(PLANNER_SUBMIT_STATUS,                (e) => {this.onSubmitStatus(e) });
  }
  // スケジュール作成ダイアログが閉じた
  onCloseDialogCreateSchedule(e){
    this.updatePlanner({
      orders_planner: {
        selectedCell: null,
        createSchedule: null
      }
    });
  }
  onCloseDialogSaveTasksMemo(e){
    this.updatePlanner({
      orders_planner: {
        selectedTasksMemo: null
      }
    });
  }
  onSubmitUnder(e){
    this.updateData({
      black_over: {
        show: false
      }
    })
    this.updatePlanner({
      orders_planner: {
        updateUnder: null
      }
    })
  }
  onSubmitStatus(e){
    this.updateData({
      black_over: {
        show: false
      }
    })
    this.updatePlanner({
      orders_planner: {
        updateStatus: null
      }
    })
  }
}
